/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_1_DescInputs */

const et_case_1_desc = /** @type {(inputs: Case_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasvatame kundalinikakao.ee orgaanilist liiklust 4 kuuga 3,3 korda. Nüüd tuleb ~70% kogu liiklusest SEO kaudu, tuues üle 140 külastaja kuus ja 3000+ näitamist otsingutulemustes. Saavutasime top 3 positsioonid kõrge ostukavatsusega märksõnadel nagu "toorkakao" ja "tseremoniaalne kakao", muutes otsingu püsivaks kliendikanaliks.`)
};

const en_case_1_desc = /** @type {(inputs: Case_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scaled kundalinikakao.ee organic traffic 3.3x in 4 months. Now ~70% of all traffic comes from SEO, generating 140+ monthly visitors and 3,000+ search impressions. Achieved top 3 rankings for high-intent keywords like "raw cacao" and "ceremonial cacao", turning search into a consistent acquisition channel.`)
};

/**
* | output |
* | --- |
* | "Scaled kundalinikakao.ee organic traffic 3.3x in 4 months. Now ~70% of all traffic comes from SEO, generating 140+ monthly visitors and 3,000+ search impress..." |
*
* @param {Case_1_DescInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const case_1_desc = /** @type {((inputs?: Case_1_DescInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_1_DescInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_case_1_desc(inputs)
	return en_case_1_desc(inputs)
});